import React from 'react';
import { Col, Form, Row, Typography } from 'components';
import { InputNumber } from 'antd';
import { preventNonNumericValue } from 'utils/helpers';
import TextArea from 'antd/es/input/TextArea';

const { Text } = Typography;

interface IGeneral {
  onFinish: () => void;
  isFinalStatus?: boolean;
}

export const General = React.memo((props: IGeneral) => {
  const { onFinish, isFinalStatus } = props;
  return (
    <Row style={{ padding: '20px' }} gutter={[0, 20]}>
      <Col span={24}>
        <Text style={{ color: '#05796B' }} className={'font-weight-800 font-size-16'}>
          General
        </Text>
      </Col>
      <Col span={24}>
        <Row gutter={[0, 20]}>
          <Col span={12}>
            <Row gutter={[10, 20]}>
              <Col span={12}>
                <Form.Item
                  name={'margin'}
                  label={'Margin'}
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value === undefined || value === null || value === '') {
                          return Promise.resolve();
                        }
                        const num = parseFloat(value);
                        if (isNaN(num)) {
                          return Promise.reject(new Error('Margin must be a valid number.'));
                        }
                        if (num < 0) {
                          return Promise.reject(new Error('Margin must be a positive number.'));
                        }
                        if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                          return Promise.reject(new Error('Margin can have up to 2 decimal points.'));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <InputNumber<number>
                    disabled={isFinalStatus}
                    controls={false}
                    size={'large'}
                    onBlur={onFinish}
                    onBeforeInput={(event: any) => preventNonNumericValue(event)}
                    style={{ width: '100%' }}
                    suffix={<Text type={'secondary'}>%</Text>}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name={'discount'}
                  label={'Discount'}
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value === undefined || value === null || value === '') {
                          return Promise.resolve();
                        }
                        const num = parseFloat(value);
                        if (isNaN(num)) {
                          return Promise.reject(new Error('Discount must be a valid number.'));
                        }
                        if (num < 0) {
                          return Promise.reject(new Error('Discount must be a positive number.'));
                        }
                        if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                          return Promise.reject(new Error('Discount can have up to 2 decimal points.'));
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <InputNumber<number>
                    disabled={isFinalStatus}
                    controls={false}
                    size={'large'}
                    onBlur={onFinish}
                    onBeforeInput={(event: any) => preventNonNumericValue(event)}
                    style={{ width: '100%' }}
                    suffix={<Text type={'secondary'}>%</Text>}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Form.Item name={'comments'} label={'Comments/ Notes'}>
              <TextArea
                disabled={isFinalStatus}
                placeholder={'Leave blank as needed'}
                style={{ resize: 'none' }}
                rows={3}
                size={'large'}
                onBlur={onFinish}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
});
